import React, { useEffect, useRef } from 'react';
import MapCoordinateCanvas from './MapCoordinateCanvas';
import './PhotoZoomModal.css';

const PhotoZoomModal = ({ imageUrl, alt = 'Level photo', title = null, onClose }) => {
    const closeButtonRef = useRef(null);

    useEffect(() => {
        closeButtonRef.current?.focus();
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <div
            className="photo-zoom-modal-overlay"
            role="dialog"
            aria-modal="true"
            aria-label={alt || 'Zoom level photo'}
            onClick={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div className="photo-zoom-modal">
                <div className="photo-zoom-modal-header">
                    {title && <h3 className="photo-zoom-modal-title">{title}</h3>}
                    <button
                        type="button"
                        ref={closeButtonRef}
                        className="photo-zoom-modal-close"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <div className="photo-zoom-modal-body">
                    <MapCoordinateCanvas
                        imageUrl={imageUrl}
                        enableZoomPan={true}
                        initialZoom={1}
                        minZoom={0.5}
                        maxZoom={8}
                        showZoomControls={true}
                        panPaddingFractionX={0.15}
                        panPaddingFractionY={0.15}
                        panPaddingScaleWithZoom={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default PhotoZoomModal;
